<template>
    <span v-if="code" :class="[`fi fi-${code?.toLowerCase()}`]" />
</template>

<script lang="ts">
    export default {
        name: 'Flag',
        props: {
            code: {
                type: String,
                required: true,
            },
        },
    };
</script>
